import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  CircularProgress,
  Box,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import { FaCheck, FaTimes } from "react-icons/fa";
import "../AgentWithdrawlRequests/AgentWithdrawlRequests.css";
import { axiosInstance } from "../../axiosInstance";
import { toast } from "react-toastify";
import { GoSearch } from "react-icons/go";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { GoDownload } from "react-icons/go";
import { FiSend } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TbFilterSearch } from "react-icons/tb";
import { IoSearchOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { CiHome } from "react-icons/ci";
import { BsEnvelope } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { GoDotFill } from "react-icons/go";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { IoAddCircleOutline } from "react-icons/io5";
import { IoMdEye } from "react-icons/io";
import { IoIosAddCircle } from "react-icons/io";

// Table columns
const wholesaler_columns = [
  {
    id: "wholesaler_id",
    label: "WHOLESALER ID",
    minWidth: 120,
    align: "center",
  },
  { id: "balance", label: "BALANCE", minWidth: 150, align: "center" },
  {
    id: "business_name",
    label: "BUSINESS NAME",
    minWidth: 150,
    align: "center",
  },

  {
    id: "email",
    label: "EMAIL",
    minWidth: 150,
    align: "center",
  },
  {
    id: "location",
    label: "LOCATION",
    minWidth: 150,
    align: "center",
  },
  {
    id: "status",
    label: "STATUS",
    minWidth: 150,
    align: "center",
  },
  {
    id: "last_credited",
    label: "LAST CREDITED",
    minWidth: 150,
    align: "center",
  },
  {
    id: "actions",
    label: "ACTIONS",
    minWidth: 150,
    align: "center",
  },
];

const retailer_columns = [
  { id: "retailer_id", label: "RETAILER ID", minWidth: 120, align: "center" },
  { id: "balance", label: "BALANCE", minWidth: 150, align: "center" },
  {
    id: "business_name",
    label: "BUSINESS NAME",
    minWidth: 150,
    align: "center",
  },

  {
    id: "email",
    label: "EMAIL",
    minWidth: 150,
    align: "center",
  },
  {
    id: "location",
    label: "LOCATION",
    minWidth: 150,
    align: "center",
  },
  {
    id: "status",
    label: "STATUS",
    minWidth: 150,
    align: "center",
  },
  {
    id: "last_credited",
    label: "LAST CREDITED",
    minWidth: 150,
    align: "center",
  },
  {
    id: "actions",
    label: "ACTIONS",
    minWidth: 150,
    align: "center",
  },
];

const transaction_columns = [
  { id: "amount", label: "AMOUNT", minWidth: 120, align: "center" },
  {
    id: "transaction_type",
    label: "TRANSACTION TYPE",
    minWidth: 150,
    align: "center",
  },
  {
   id:"reason",
   label :"Reason for debit/credit",
    minWidth: 150,
    align: "center",
  },
  {
    id: "credited_at",
    label: "CREDITED AT",
    minWidth: 150,
    align: "center",
  },
];
const formatDate = (dateString) => {
  if (!dateString) return "--";
  const date = new Date(dateString);
  if (isNaN(date)) return "--";
  return date.toLocaleDateString("en-GB");
};
export const GomakCash = () => {
  const [error, setError] = useState("");
  const [gomakCashList, setGomakCashList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [activeEdit, setactiveEdit] = useState("wholesaler");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchGomakCash = async (city = selectedCity) => {
    setLoading(true);
    setError("");
    try {
      const config = {
        params: {
          user_type: activeEdit,
          search: searchQuery,
          page: page + 1,
          page_size: rowsPerPage,
          filter: city || undefined,
        },
      };

      const res = await axiosInstance.get("/admin/gomakcash-list/", config);
      if (res.data.status === "success") {
        setGomakCashList(res.data.data.results || []);
        setTotalCount(res.data.data.count || 0);
      } else {
        setError("Failed to fetch gomak cash list.");
      }
    } catch (err) {
      console.error("Error fetching gomak cash list:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(0);
  }, [activeEdit, searchQuery]);

  useEffect(() => {
    fetchGomakCash();
  }, [page, rowsPerPage, searchQuery, activeEdit]);

  //filter modal state start here
  const [showFilter, setShowFilter] = useState(false);
  const [citySearch, setCitySearch] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [ryderZoneList, setRyderZoneList] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const fetchRyderZone = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/admin/ryder-zones/");

      if (res.data.status === "success") {
        const data = res.data.data || [];

        setRyderZoneList(data);

        // Extract unique cities
        const uniqueCities = [...new Set(data.map((item) => item.city))];

        // Convert for react-select
        const formattedCities = uniqueCities.map((city) => ({
          value: city,
          label: city,
        }));

        setCityOptions(formattedCities);
      }
    } catch (err) {
      console.error("Error fetching RyderZone data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRyderZone();
  }, []);

  const filteredCityOptions = cityOptions.filter((city) =>
    city.label.toLowerCase().includes(citySearch.toLowerCase()),
  );

  const handleCitySelect = (city) => {
    setSelectedCity(city);
  };

  function applyFilters() {
    fetchGomakCash();
    setShowFilter(false);
  }

  // Clear all filters
  const clearFilters = () => {
    setSelectedCity("");
    fetchGomakCash("");
  };

  // Add cash modal
  const [addcashModal, setAddCashModal] = useState(false);
  // const [toggleType, setToggleType] = useState("");
  const [wholesaler, setWholesaler] = useState("");
  const [retailer, setRetailer] = useState("");

  const handleAddModalOpen = (row) => {
    setAddCashModal(true);
    if (activeEdit === "wholesaler") {
      setWholesaler(row);
    } else {
      setRetailer(row);
    }
  };

  const handleAddModalClose = () => {
    setAddCashModal(false);
    setGomakAmount("");
    setGomakCashError("");
    setAddNote("");
  };
  // add gomak cash

  const [gomakAmount, setGomakAmount] = useState("");
  // const [applyType, setApplyType] = useState("individual");
  const [gomakCashError, setGomakCashError] = useState("");
  const [addNote, setAddNote] = useState("");

  async function addGomakCash() {
    try {
      // Required validation
      if (gomakAmount === "") {
        setGomakCashError("Gomak cash amount is required");
        return false;
      }

      if (Number(gomakAmount) < 0) {
        setGomakCashError("Gomak cash amount cannot be negative");
        return false;
      }
      setGomakCashError("");

      setLoading(true);
      const payload = {
        apply_to: "individual",
        user_type: activeEdit,
        wholesalers: activeEdit === "wholesaler" ? [wholesaler.user_id] : [],
        retailers: activeEdit === "retailer" ? [retailer.user_id] : [],
        amount: Number(gomakAmount),
        reason: addNote,
        ryder_zone:
          activeEdit === "wholesaler" ? wholesaler.location : retailer.location,
        transaction_source: "admin",
      };
      const response = await axiosInstance.post(
        "/admin/gomakcash-addition-user-wallet/",
        payload,
      );
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data?.message);
        handleAddModalClose();
        fetchGomakCash();
        return true;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add gomak cash");
      console.log(error?.response?.data?.message || "Failed to add gomak cash");
      return false;
    } finally {
      setLoading(false);
    }
  }

  //View modal
  const [viewModal, setViewModal] = useState(false);

  const [transactionHistory, setTransationHistory] = useState([]);

  async function FetchTransactionHistory(id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/admin/gomakcash-wallet-transaction/${id}/`,
      );
      if (response.data.status === "success" || response.status === 200) {
        setTransationHistory(response.data?.data);
      }
    } catch (error) {
      toast.error(
        error.response.data?.data || "Failed to fetch transaction history",
      );
      console.log(
        error.response.data?.data || "Failed to fetch transaction history",
      );
    } finally {
      setLoading(false);
    }
  }

  // toggler status update 
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);

  const handleToggleClick = (row) => {
    setToggleTarget(row);
    setToggleModalOpen(true);
  };

  const handleToggleStatus = async () => {
    try {
      let res;

      if (activeEdit === "wholesaler") {
        res = await axiosInstance.patch(
          `/admin/gomakcash-wallet-update/${toggleTarget.wholesaler_id}/`,
          {
            is_active: !toggleTarget.status,
          },
        );
      } else {
        res = await axiosInstance.patch(
          `/admin/gomakcash-wallet-update/${toggleTarget.retailer_id}/`,
          {
            is_active: !toggleTarget.status,
          },
        );
      }

      if (res.status === 200) {
        toast.success(res.data.message || "Status updated successfully");

        fetchGomakCash();

        setToggleModalOpen(false);
        setToggleTarget(null);
      } else {
        toast.error("Failed to update status");
      }
    } catch (err) {
      console.error(err.res.data.message || "Error updating status:", err);
      toast.error(err.res.data.message || "Error updating status");
    }
  };

  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "#1265c5" }} />
          </Stack>
        </div>
      )}
      <div>
        <div>
          <div className="admin-listText">Ride Wallet</div>
          <div style={{ color: "#666768", fontSize: "14px" }}>
            Manage and send free ride wallet amount to wholesalers and retailers
          </div>
        </div>
        <div className="gomak-cash-searchContainer">
          <div className="search-container">
            <div className="nav-search">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ border: "none", outline: "none", marginLeft: "6px" }}
              />
            </div>
          </div>
          <div className="btnFilter">
            <button onClick={() => setShowFilter(true)}>
              <TbFilterSearch /> Filter
            </button>
          </div>
        </div>
        {/* Selected Filters */}
        {selectedCity && (
          <div>
            <div className="filteredDataText">
              <div>Filtered Results</div>

              <div onClick={clearFilters} style={{ cursor: "pointer" }}>
                <MdDeleteOutline />
                <span className="ps-1">Clear</span>
              </div>
            </div>
            <div>
              {selectedCity && (
                <div className="seletedFilter">
                  <div className="city-filter-chip">
                    <span className="pe-1">{selectedCity}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Tabs  */}
        <div className="wholesalerMenu mb-3">
          <div
            onClick={() => {
              setactiveEdit("wholesaler");
            }}
            className={`edit-menu ${
              activeEdit === "wholesaler" ? "activeEdit" : ""
            }`}
          >
            Wholesaler List
          </div>
          <div
            onClick={() => {
              setactiveEdit("retailer");
            }}
            className={`edit-menu ${
              activeEdit === "retailer" ? "activeEdit" : ""
            }`}
          >
            Retailer List
          </div>
        </div>
        {activeEdit === "wholesaler" && (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {wholesaler_columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell
                        colSpan={wholesaler_columns.length}
                        align="center"
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : gomakCashList.length > 0 ? (
                    gomakCashList
                      // .slice(
                      //   page * rowsPerPage,
                      //   page * rowsPerPage + rowsPerPage,
                      // )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={`${activeEdit}-${row.wholesaler_id}`}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#F9FAFB" : "white",
                          }}
                        >
                          <TableCell align="center">
                            {row.wholesaler_id}
                          </TableCell>
                          <TableCell align="center">{row.balance}</TableCell>
                          <TableCell align="center">
                            {row.business_name ?? "-"}
                          </TableCell>

                          <TableCell align="center">{row.email}</TableCell>
                          <TableCell align="center">{row.location}</TableCell>
                          {/* Status Toggle */}
                          <TableCell align="center">
                            <div
                              className="form-check form-switch d-flex justify-content-center"
                              style={{ marginTop: "5px" }}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`toggleSwitch-${row.wholesaler_id}`}
                                checked={Boolean(row.status)}
                                onChange={() => handleToggleClick(row)}
                              />

                              <label
                                className="form-check-label"
                                htmlFor={`toggleSwitch-${row.wholesaler_id}`}
                              />
                            </div>
                          </TableCell>

                          <TableCell align="center">
                            {formatDate(row.last_updated)}
                          </TableCell>
                          <TableCell align="center">
                            <IoMdEye
                              style={{
                                cursor: "pointer",
                                color: "#4184D1",
                                fontSize: "16px",
                                marginRight: "10px",
                              }}
                              onClick={() => {
                                setViewModal(true);
                                FetchTransactionHistory(row.wholesaler_id);
                              }}
                            />
                            <IoIosAddCircle
                              style={{
                                cursor: "pointer",
                                color: "#4184D1",
                                fontSize: "16px",
                              }}
                              onClick={() => handleAddModalOpen(row)}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={wholesaler_columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        Data Not Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[
                20, 30, 50, 100, 500, 1000, 2000, 5000, 10000,
              ]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
        {activeEdit === "retailer" && (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {retailer_columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell
                        colSpan={retailer_columns.length}
                        align="center"
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : gomakCashList.length > 0 ? (
                    gomakCashList
                      // .slice(
                      //   page * rowsPerPage,
                      //   page * rowsPerPage + rowsPerPage,
                      // )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={`${activeEdit}-${row.retailer_id}`}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#F9FAFB" : "white",
                          }}
                        >
                          <TableCell align="center">
                            {row.retailer_id}
                          </TableCell>
                          <TableCell align="center">{row.balance}</TableCell>
                          <TableCell align="center">
                            {row.business_name ?? "-"}
                          </TableCell>

                          <TableCell align="center">{row.email}</TableCell>
                          <TableCell align="center">{row.location}</TableCell>
                          <TableCell align="center">
                            <div
                              className="form-check form-switch d-flex justify-content-center"
                              style={{ marginTop: "5px" }}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`toggleSwitch-${row.retailer_id}`}
                                checked={Boolean(row.status)}
                                onChange={() => handleToggleClick(row)}
                              />

                              <label
                                className="form-check-label"
                                htmlFor={`toggleSwitch-${row.retailer_id}`}
                              />
                            </div>
                          </TableCell>
                          <TableCell align="center">
                            {formatDate(row.last_updated)}
                          </TableCell>
                          <TableCell align="center">
                            <IoMdEye
                              style={{
                                cursor: "pointer",
                                color: "#4184D1",
                                fontSize: "16px",
                                marginRight: "10px",
                              }}
                              onClick={() => {
                                setViewModal(true);
                                FetchTransactionHistory(row.retailer_id);
                              }}
                            />
                            <IoIosAddCircle
                              style={{
                                cursor: "pointer",
                                color: "#4184D1",
                                fontSize: "16px",
                              }}
                              onClick={() => handleAddModalOpen(row)}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={retailer_columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        Data Not Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[
                20, 30, 50, 100, 500, 1000, 2000, 5000, 10000,
              ]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}

        {/* Add cash modal  */}
        <Modal
          show={addcashModal}
          onHide={handleAddModalClose}
          centered
          size="lg"
          className="gomakcash-toggler-model"
        >
          <Modal.Header closeButton>
            <div className="gomak-cash-togglerModelHeader">
              <h2>{`Add Amount to ${activeEdit === "wholesaler" ? "Wholesaler" : "Retailer"}`}</h2>
              <p>{`Add ride wallet amount for the selected ${activeEdit === "wholesaler" ? "wholesaler" : "retailer"}`}</p>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="gomakcash-toggler-content">
              <p>{`Selected ${activeEdit === "wholesaler" ? "Wholesaler" : "Retailer"}`}</p>
              <div className="d-flex gap-4">
                <div className="d-flex gap-2">
                  <div className="toggler-home">
                    <CiHome />
                  </div>
                  <div className="d-flex flex-column">
                    <span className="toggler-selected-title">
                      {activeEdit === "wholesaler"
                        ? wholesaler.business_name
                        : retailer.business_name}
                    </span>
                    <span className="toggler-selected-desc">
                      {activeEdit === "wholesaler"
                        ? wholesaler.wholesaler_id
                        : retailer.retailer_id}
                    </span>
                  </div>
                </div>
                <div className="toggler-selected-desc">
                  <span className="me-1">
                    <BsEnvelope />
                  </span>
                  {activeEdit === "wholesaler"
                    ? wholesaler.email
                    : retailer.email}
                </div>
                <div className="toggler-selected-desc">
                  <span className="me-1">
                    <CiLocationOn />
                  </span>
                  {activeEdit === "wholesaler"
                    ? wholesaler.location
                    : retailer.location}
                </div>
                <div className="toggler-selected-desc text-success">
                  <span className="me-1">
                    <GoDotFill />
                  </span>
                  {activeEdit === "wholesaler"
                    ? wholesaler.status === true
                      ? "Active"
                      : "Inactive"
                    : retailer.status === true
                      ? "Active"
                      : "Inactive"}
                </div>
              </div>
            </div>
            <div className="toggler-modal-input">
              <label>
                {" "}
                Amount to Add (₹) <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                // min={0}

                placeholder="Enter Amount"
                value={gomakAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  setGomakAmount(value);

                  // Clear error when enters a valid value
                  if (value !== "" && Number(value) >= 0) {
                    setGomakCashError("");
                  }
                }}
              />
              <div style={{ color: "red", fontSize: "12px" }}>
                {gomakCashError}
              </div>
            </div>
            <div className="toggler-modal-input">
              <label>Add Note (Optional)</label>
              <textarea
                rows={4}
                placeholder="Enter note (optional)"
                onChange={(e) => setAddNote(e.target.value)}
                value={addNote}
              ></textarea>
            </div>
            <div className="toggler-model-note">
              <span style={{ color: "#FF8904" }} className="me-2">
                <IoIosInformationCircleOutline />
              </span>
              <span>{`The amount added will be credited to the ${activeEdit === "wholesaler" ? "wholesaler's" : "retailer's"} selected wallet immediately.`}</span>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              display: "grid",
              gridTemplateColumns: "6fr 6fr",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              type="button"
              className="btnCancelTogglerModel"
              onClick={handleAddModalClose}
            >
              Cancel
            </Button>
            <Button
              className="btnAddTogglerModel"
              type="submit"
              onClick={() => addGomakCash()}
            >
              <span className="me-1">
                <IoAddCircleOutline />
              </span>
              Add Amount
            </Button>
          </Modal.Footer>
        </Modal>

        {/* view modal  */}
        <Modal
          show={viewModal}
          onHide={() => setViewModal(false)}
          centered
          size="lg"
          className="gomakcash-toggler-model"
        >
          <Modal.Header closeButton>
            <div className="gomak-cash-togglerModelHeader">
              <h2>Transaction History</h2>
            </div>
          </Modal.Header>
          <Modal.Body>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer
                sx={{ maxHeight: 440 }}
                className="Table-container"
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {transaction_columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                          className="table-header"
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell
                          colSpan={transaction_columns.length}
                          align="center"
                        >
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : transactionHistory.length > 0 ? (
                      transactionHistory
                        // .slice(
                        //   page * rowsPerPage,
                        //   page * rowsPerPage + rowsPerPage,
                        // )
                        .map((row, index) => (
                          <TableRow
                            className="table-row"
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={`${activeEdit}-${row.id}`}
                            sx={{
                              backgroundColor:
                                index % 2 === 1 ? "#F9FAFB" : "white",
                            }}
                          >
                            <TableCell align="center">₹ {row.amount ?? "---"}</TableCell>
                            <TableCell align="center">
                              {row.transaction_type ?? "---"}
                            </TableCell>
                             <TableCell align="center">
                              <span>{row.reason ?? "---"}</span> <br/>
                              <span>{row.order_id ? `ORDER ID : ${row.order_id}`:""}</span>
                            </TableCell>

                            <TableCell align="center">
                              {dayjs(row.created_at).format(
                                "DD-MM-YYYY hh:mm A",
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={wholesaler_columns.length}
                          align="center"
                          style={{ padding: "40px 0" }}
                        >
                          Data Not Available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Modal.Body>
          <Modal.Footer
          // style={{
          //   display: "grid",
          //   gridTemplateColumns: "6fr 6fr",
          //   gap: "10px",
          //   width: "100%",
          // }}
          >
            <Button
              className="btnAddTogglerModel"
              onClick={() => setViewModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* filter modal  */}
        <Modal
          show={showFilter}
          onHide={() => {
            setShowFilter(false);

            // Reset search
            setCitySearch("");
          }}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {/* city Filter */}
              <div className="filterState">
                <div className="filterTitle">Filter by City</div>
                <div className="searchContainer">
                  <IoSearchOutline className="searchIcon" />
                  <input
                    type="text"
                    placeholder="Search any city"
                    value={citySearch}
                    onChange={(e) => setCitySearch(e.target.value)}
                  />
                </div>
                {filteredCityOptions.map((city) => (
                  <div className="stateList" key={city.value}>
                    <input
                      type="checkbox"
                      checked={selectedCity.includes(city.value)}
                      onChange={() => handleCitySelect(city.value)}
                    />

                    <span>{city.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btnCancelFilter"
              onClick={() => {
                setShowFilter(false);

                // Reset search
                setCitySearch("");
              }}
            >
              Cancel
            </Button>
            <Button className="btnApplyFilter" onClick={applyFilters}>
              Apply Filter
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* status toggler  */}
      <Modal
        show={toggleModalOpen}
        onHide={() => setToggleModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="toggle-status-title">Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Do you want to {toggleTarget?.status ? "INACTIVATE" : "ACTIVATE"} ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setToggleModalOpen(false);
              setToggleTarget(null);
            }}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleToggleStatus}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
